/** @jsx jsx */

/** @jsxFrag React.Fragment */
import React, { useState, useRef, useEffect } from 'react';
import { Global } from '@emotion/core';
import { jsx, Box } from 'theme-ui';
import { useMenus, useCurrentDoc } from 'docz';
import * as styles from './styles';
import { NavSearch } from '../NavSearch';
import { NavLink } from '../NavLink';
import { NavGroup } from '../NavGroup';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Sidebar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useState = useState(''),
      query = _useState[0],
      setQuery = _useState[1];

  var menus = useMenus({
    query: query
  });
  var currentDoc = useCurrentDoc();
  var currentDocRef = useRef();

  var handleChange = function handleChange(ev) {
    setQuery(ev.target.value);
  };

  useEffect(function () {
    if (ref.current && currentDocRef.current) {
      ref.current.scrollTo(0, currentDocRef.current.offsetTop);
    }
  }, []);
  return jsx(React.Fragment, null, jsx(Box, {
    onClick: props.onClick,
    sx: styles.overlay(props)
  }, props.open && jsx(Global, {
    styles: styles.global
  })), jsx(Box, {
    ref: ref,
    sx: styles.wrapper(props),
    "data-testid": "sidebar"
  }, jsx(NavSearch, {
    placeholder: "Type to search...",
    value: query,
    onChange: handleChange
  }), menus && menus.map(function (menu) {
    if (!menu.route) return jsx(NavGroup, {
      key: menu.id,
      item: menu,
      sidebarRef: ref
    });

    if (menu.route === currentDoc.route) {
      return jsx(NavLink, {
        key: menu.id,
        item: menu,
        ref: currentDocRef
      }, menu.name);
    }

    return jsx(NavLink, {
      key: menu.id,
      item: menu
    }, menu.name);
  })));
});

if (typeof Sidebar !== 'undefined' && Sidebar && Sidebar === Object(Sidebar) && Object.isExtensible(Sidebar) && !Sidebar.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Sidebar, '__filemeta', {
    configurable: true,
    value: {
      name: "Sidebar",
      filename: "node_modules/gatsby-theme-docz/src/components/Sidebar/index.js"
    }
  });
}